import OfferDetail from './OfferDetail';

export default OfferDetail;
